import "./IconRow.css";

function IconRow({ center = false }) {
  return (
    <div
      className="icon-row"
      style={center ? { justifyContent: "center" } : {}}
    >
      <a
        href="https://instagram.com/ballerbearsnft"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa-brands fa-instagram"></i>
      </a>
      <a href="https://discord.gg/sRpvtuywUt" target="_blank" rel="noreferrer">
        <i className="fa-brands fa-discord"></i>
      </a>
      <a
        href="https://twitter.com/ballerbearsnft"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa-brands fa-twitter"></i>
      </a>
    </div>
  );
}

export default IconRow;
